export default {
  domainDirectory: {
    title: "公式ドメイン", subtitle: "公式サイトはこちらで確認できます。タップしてコピー。", available: "件接続可能",
    loading: "読み込み中…", loadFailed: "読み込みに失敗しました", retry: "再読み込み", empty: "有効なドメインはありません",
    tapToCopy: "タップしてコピー", checking: "確認中", checkingShort: "確認中", online: "接続可能", offline: "接続タイムアウト",
    waiting: "確認待ち", timeout: "タイムアウト", testAll: "すべてのドメインをテスト", updatedEveryFifteenSeconds: "接続状態は15秒ごとに自動確認されます",
    saveReminder: "ドメイン情報を残すため、このページをスクリーンショットで保存してください", copied: "ドメインをコピーしました",
    names: { primary: "メインドメイン", chinaAccel: "中国向け加速", secondary: "サブドメイン" },
  },
  nickname: {"edit": "ニックネーム編集", "hint": "2～20文字の日本語/英字、数字または _", "saved": "ニックネームを保存しました", "taken": "このニックネームは既に使用されています", "invalid": "2～20文字の日本語/英字、数字または _ を入力してください。公式予約名は使用できません。", "failed": "保存に失敗しました。再試行してください。"},
  common: {
    confirm: "確認",
    cancel: "キャンセル",
    search: "検索",
    language: "言語",
    pleaseRelogin: "ログインの有効期限が切れました。再度ログインしてください",
    switched: "切り替えました",
    currentLanguage: "現在の言語",
    selectLanguage: "言語を選択",
    loading: "読み込み中...",
    loadingMore: "さらに読み込み中...",
    noMoreData: "これ以上データはありません",
    noData: "データがありません",
    serverUnavailable: "サーバーが一時的に利用できません",
    loadFailed: "読み込みに失敗しました",
    requestFailed: "リクエストに失敗しました",
    retry: "再試行",
    projectName: "PANTA MARKET",
    duplicateSubmission: "重複して送信しないでください",
    fee: "手数料",
    submit: "送信",
    tip: "お知らせ",
    connecting: "接続中...",
    connectWalletFirst: "先にウォレットを接続してください",
    connect: "接続",
    insufficientBalance: "残高不足",
    developing: "機能は開発中です",
    copyFailed: "コピーに失敗しました",
    sessionAuthRelogin: "再ログイン",
    sessionAuthStay: "そのまま",
    pager: {
      prevPage: "前へ",
      nextPage: "次へ",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "移動",
      jumpConfirm: "決定",
    },
  },
  tabbar: {
    home: "ホーム",
    market: "タイムライン",
    timeline: "タイムライン",
    prediction: "AIイベント契約予測",
    createMarket: "マーケット作成",
    planet: "交易",
    trade: "取引",
    finance: "金融",
    fund: "ファンド",
    assets: "資産",
    planethistory: "購入履歴"
  },
  tradeMenu: {
    contract: "イベント契約",
    insurance: "保険",
    spot: "現物",
    flash: "フラッシュスワップ"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI予測 · イベント契約 · スマート分析",
    predictionCategories: {
      hot: "タイムライン",
      sports: "スポーツ",
      world: "世界",
      politics: "政治",
      economy: "経済"
    },
    predictionSubCategories: {
      crypto: "現物",
      forex: "外為",
      commodities: "コモディティ"
    },
    features: {
      recharge: "入金",
      rechargeDesc: "迅速な入金",
      contract: "イベント契約",
      contractDesc: "革新的な金融ツール",
      predict: "AI予測",
      fund: "PANTA MARKET Treasury",
      invite: "友達を招待",
      global: "グローバルノード"
    },
    insurance: {
      title: "契約保険プール(TAKER)",
      aiPoolTitle: "AI保険プール",
      ordinaryPoolTitle: "一般保険バリュープール",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA（参考）",
      more: "詳細を見る",
      yesterday: "昨日の追加",
      service: "スマートサービス"
    },
    market: {
      tabs: {
        main: "主要",
        hot: "人気",
        rise: "上昇ランキング",
        price: "価格ランキング"
      },
      headers: {
        pair: "ペア",
        latest: "最新価格",
        change: "24時間変動幅"
      },
      viewMore: "もっと見る",
      collapse: "閉じる"
    },
    announcement: {
      title: "お知らせ",
      heading: "お知らせ",
      text: "PANTA MARKETへようこそ。ここでは、PANTA MARKET独自のAIと予測保険システムを体験し、簡単にWEB3予測市場に参加し、富の旅を始めることができます。",
      time: "2025/11/19 10:00",
      gotIt: "お知らせを確認しました",
      viewDetail: "詳細を見る",
      systemLabel: "システムお知らせ"
    },
    timePeriods: {
      "1min": "1分",
      "30min": "30分",
      "1hour": "1時間"
    },
    footer: {
      australia: "· オーストラリア",
      uae: "· アラブ首長国連邦",
      attention: "· 注意:",
      attentionText: "PANTA MARKETは、AIベースの自己運営型WEB3予測市場会社です。いかなる形式や名前であれ、第三者による料金の徴収を許可していません。お問い合わせは、公式カスタマーサービスまでご連絡ください：{email}"
    },
    timeframes: {
      "1s": "1分",
      "1m": "1分",
      "5m": "5分",
      "15m": "15分",
      "1h": "1時間",
      "4h": "4時間",
      "1d": "1日"
    },
    statusHotEn: "HOT",
    yes: "はい",
    no: "いいえ",
    hotBannerTitle: "イベント契約",
    homeBanner: {
      s1t1: "AI搭載の",
      s1t2: "AstralXコア生態系",
      s1cta: "AstralX",
      s2t: "Galaxyファンド",
      s2s1: "元本保護について",
      s2s2: "と配当ルール",
      s2cta: "申込へ",
      s3s: "価格予測",
      s3cta: "予測する",
    },
    catCrypto: "暗号資産",
    catMetal: "貴金属",
    catSports: "スポーツ",
    catPolitics: "政治",
    catEntertainment: "エンタメ",
    statusHot: "人気",
    statusLocked: "ロック",
    statusLive: "進行中",
    statusLockedWait: "ロック・決済待ち",
    jouleUnit: "JOULE",
    nowLabel: "現在",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "他{n}件のオプション",
    categoryAll: "すべて",
    categoryCrypto: "暗号資産",
    categoryEquity: "株式",
    categoryCommodity: "コモディティ",
    categoryForex: "Forex",
    categoryMetal: "Metals"
  },
  withdraw: {
    title: "出金",
    headerTitle: "出金",
    address: "出金アドレス",
    addressLabel: "出金アドレス",
    addressPlaceholder: "アドレスを入力または貼り付け",
    network: "ネットワーク",
    selectNetwork: "ネットワークを選択",
    networkHint: "出金アドレスが選択したネットワークと一致することを確認してください",
    withdrawAmount: "出金金額",
    receiveAmount: "受取金額",
    networkFee: "ネットワーク手数料",
    submit: "出金を確認",
    submitButton: "出金",
    balance: "残高：",
    all: "すべて",
    amountPlaceholder: "入力してください",
    minimumWithdrawal: "最低出金額：{amount} USDT",
    fee: "手数料",
    confirm: "確認",
    confirmTitle: "操作の確認",
    confirmContent: "この操作を実行してもよろしいですか？",
    toasts: {
      fetchFailed: "資産の取得に失敗しました",
      enterAddress: "出金アドレスを入力してください",
      enterValidAmount: "有効な出金額を入力してください",
      insufficientBalance: "残高不足",
      minimumAmount: "最低出金額は{amount} USDTです",
      processing: "処理中...",
      success: "出金成功！",
      requestSuccess: "出金申請に成功しました",
      requestFailed: "出金に失敗しました、もう一度お試しください",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "入金",
    connectPrompt: "入金するには、まずウォレットを接続してください",
    amaBalance: "TAKER残高",
    amount: "金額",
    amountPlaceholder: "入金額を入力してください",
    minimumNotice: "*最低 {min} {token}",
    processing: "処理中...",
    confirm: "入金を確認",
    helpText: "入金はスマートコントラクトのrechargeメソッドを呼び出します。TAKERトークンの承認が必要です",
    toasts: {
      enterValidAmount: "有効な入金額を入力してください",
      invalidAmount: "入金額は{min} TAKER以上である必要があります",
      checkingAllowance: "限度額を確認中...",
      approving: "承認中...",
      approveSuccess: "承認に成功しました",
      depositing: "入金中...",
      depositSuccess: "入金に成功しました",
      depositFailed: "入金に失敗しました",
      balanceLoadFailed: "ウォレットのテストUSDT残高を取得できません。更新して再試行してください",
      contractError: "コントラクト呼び出しに失敗しました。残高を確認してください",
      userCancelled: "操作をキャンセルしました",
      insufficientFunds: "残高不足",
      wrongNetwork: "正しいネットワークに切り替えてください",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "私のチーム",
    contractEarnings: "私の契約収益",
    btcFund: "運用収益",
    stats: {
      teamSubscribed: "チームステーキング",
      personalSubscribed: "個人ステーキング",
      totalTeam: "チーム出来高",
      periodTeam: "チーム収益",
      periodPersonal: "個人出来高",
      personalEarnings: "個人累計収益",
      teamEarnings: "チーム収益",
      personalVolume: "個人出来高",
      teamVolume: "チーム出来高",
      personalPower: "個人算力",
      teamTotalPower: "チーム総算力"
    },
    links: {
      invite: "友達を招待",
      details: "チーム詳細"
    },
    inviteBannerTitle: "友達を招待してチーム報酬を解除",
    inviteBannerSubtitle: "チーム報酬をアンロック",
    inviteBannerCta: "今すぐ参加",
    unclassifiedHint: "過去の支払元の確認待ち：{amount} {asset}"
  },
  my: {
    headerTitle: "マイページ",
    login: "タップしてログイン",
    inviteCode: "招待コード：",
    groups: {
      common: "共通機能",
      trading: "取引",
      finance: "金融",
      help: "ヘルプ"
    },
    features: {
      invite: "友達を招待",
      team: "私のチーム",
      insurance: "イベント契約保険",
      contract: "イベント契約",
      exchange: "両替",
      fund: "AI財源ファンド",
      communitySquare: "コミュニティ広場",
      createEvent: "イベント作成",
      community: "公式コミュニティ",
      terms: "利用規約",
      announcement: "お知らせ",
      privacy: "プライバシーポリシー",
      aboutUs: "会社概要"
    }
  },
  finance: {
    title: "金融ページは開発中です..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "交換失敗：条件を満たしていません",
    internalPrice: "内部価格",
    marketPrice: "市場価格",
    coinBasis: "コイン建て",
    legacyBasis: "コイン建て",
    contractBasis: "決済区分",
    unitPrice: "購入単価",
    quotaUsed: "内部価格での累計購入",
    quotaRemaining: "内部価格の残り枠",
    quotaHint: "全プラン合計で生涯{limit} PANTAまで。内部価格の停止、満期、VIP変更でも累計はリセットされません。",
    principal: "元本",
    principalReturn: "満期返還元本",
    dailyYield: "1日の総利息",
    coinYieldHint: "1日の総利息 = PANTA元本 × 年利 ÷ 360（最小単位で切り捨て）。価格変動で契約枚数は変わりません。分配は適用ルールに従います。",
    legacyHint: "コイン建て契約です。元本のPANTA返還は契約上の満期価格で換算されます。",
    quotaError: "内部価格の残り枠を超えています。数量を減らしてください。自動分割や市場価格への切替は行いません。",
    permissionChanged: "現在のVIPではこのプランを購入できません。一覧を更新しました。",
    quoteChanged: "価格または資格が変わりました。新しい見積りを確認して再度確定してください。",
    quoteExpired: "見積りの期限が切れました。更新して確認してください。",
    retryQuote: "見積りを更新",
    stakeGateTitle: "PANTA売却のステーキング条件",
    stakeGateBody: "VIP{vip}：有効ステーク {staked} PANTA、必要 {required} PANTA、不足 {shortfall} PANTA。売却のみ制限され、購入には影響しません。",
    goStake: "ステーキングへ",
    refreshEligibility: "資格を更新",
  },
  fundPage: {
    heroTitle: "毎日PANTA収益を配布",
    heroDesc: "Galaxyファンドを申込み、年率配当を獲得",
    learnMore: "詳しく見る",
    allProducts: "すべての商品",
    subscribe: "申込み",
    stake: "ステーキング",
    stakePreview: "ステーキング確認",
    searchCoin: "コインを検索",
    allPeriods: "すべての期間",
    colCoin: "ファンド名",
    colApy: "コイン建て年率",
    colTerm: "期間",
    fixedTerm: "定期",
    galaxyProduct: "Galaxy {n}号",
    termLabel: "期間",
    apyLabel: "年率",
    stakeCap: "個人保有",
    stakeAmount: "ステーキング金額",
    estEarnings: "予想収益",
    stakeDisclaimer: "収益は参考値であり保証ではありません。入金額の約70%は利用可能残高、30%は体験金へ配分され、体験金は約3倍の取引量達成後に解除されます。",
    stakeSuccess: "ステーキング成功",
    annualized: "参考年率",
    perShareYield: "万口収益(WBS)",
    dayUnit: "日",
    empty: "ファンド商品がありません",
    loadFailed: "読み込みに失敗しました",
    rulesTitle: "ファンド説明",
    gotIt: "了解しました",
    pantaAvailable: "PANTA 利用可能",
    activeFaceValue: "運用中の口数",
    totalReward: "ファンド累計収益(PANTA)",
    fundYieldUnavailable: "--/サービスを更新してください",
    effectiveVip: "有効ランク",
    myHoldings: "ファンド購入履歴",
    faceValue: "価値",
    maturity: "満期",
    stakeStart: "ステーキング日時",
    pantaPrice: "PANTA 単価",
    noMoreHoldings: "これ以上の保有はありません",
    subscriptionStatus: {
      ACTIVE: "運用中",
      SETTLED: "決済済み",
      CANCELLED: "取消済み",
      MANUAL_REVIEW: "手動審査",
    },
    minPanta: "最低申込 PANTA",
    pantaAmount: "申込数量（PANTA）",
    stepHint: "{step} の整数倍、最低 {min}",
    getQuote: "見積りを取得",
    confirmStake: "ステーキングを確認",
    jouleDebit: "JOULE 控除",
    expectedPanta: "ステーキング PANTA",
    quoteExpires: "見積り有効期限",
    unavailable: "現在利用できません",
    invalidAmount: "有効なPANTAステップ数量を入力してください",
    quoteFailed: "見積りに失敗しました",
    rewards: "ファンド報酬",
    unlock: "PANTA 凍結バッチ",
    unlockProgress: "使用済み取引量",
    pantaLedger: "PANTA 台帳"
  },
  finanfund: {
    title: "PANTA MARKET財務ファンド",
    subtitle: "シンプル・効率的・簡単に稼ぐ",
    productName: "PANTA MARKET財務ファンド",
    minAmount: "最低金額",
    incomeRatio: "収益率",
    lockPeriod: "ロック期間",
    dailyReturn: "日次収益",
    earning: "獲得",
    redemptionRules: "償還ルール",
    rules: {
      rule1: "PANTA MARKET財務ファンドは預託後に償還できません",
      rule2: "日次収益は自動的に入金されます",
      rule3: "ロック金額はロック期間終了後に返還されます"
    },
    subscription: "申込",
    amountPlaceholder: "金額を入力",
    balance: "残高",
    availableFunds: "利用可能資金",
    all: "すべて",
    subscribeButton: "申込",
    toasts: {
      productIdNotExist: "商品IDが存在しません",
      enterValidAmount: "有効な申込金額を入力してください",
      minAmountRequired: "申込金額は{amount} USDT以上である必要があります",
      subscribeSuccess: "申込成功",
      subscribeFailed: "申込失敗"
    }
  },
  community: {
    title: "公式コミュニティ",
    bannerTitle1: "コミュニティに参加",
    bannerTitle2: "グローバルユーザーと交流",
    linkCopied: "リンクをコピーしました"
  },
  invite: {
    headerTitle: "友達を招待",
    rulesEntry: "招待ルール",
    subtitle: "チームの取引ごとに報酬",
    mainTitle: "招待で稼ぐ",
    description: "リンクを共有し、友達が取引すると報酬",
    yourCode: "招待コード",
    shareLink: "共有リンク",
    inviteButton: "友達を招待",
    subTitle: "高額なコミッションを獲得",
    viewRules: "推薦ルールを見る",
    rulesLink: "紹介ルールを見る >",
    rulesTitle: "紹介ルール",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "友達を招待",
    referralCode: "紹介コード",
    inviteLink: "招待リンク",
    loading: "読み込み中...",
    copyButton: "招待リンクをコピー",
    toasts: {
      emptyContent: "内容が空です",
      copySuccess: "コピーしました",
      bindSuccess: "紐付け成功",
      bindFailed: "バインド失敗",
      alreadyBound: "上位は既に紐付け済みで変更できません",
      loginFirst: "先にウォレットを接続してください",
      invalidCode: "有効な招待コードまたはウォレットアドレスを入力してください",
      cannotBindSelf: "自分自身は紐付けできません",
    },
    boundLabel: "上位が紐付け済み",
    modalDesc: "まだ上位が紐付けられていません。招待コードかウォレットアドレスを入力するとチーム報酬に参加できます。招待リンクの情報は自動入力され、無い場合はデフォルトの上位が事前入力されます。",
    bindPlaceholder: "招待コードまたはウォレットアドレス",
    bindButton: "紐付け",
    binding: "紐付け中…",
    bindSuperior: "上位を紐付け",
  },
  wallet: {
    title: "マイウォレット",
    address: "ウォレットアドレス",
    addressCopied: "アドレスをコピーしました",
    inviteCode: "招待コード",
    logout: "ログアウト",
    login: "ログイン",
    toasts: {
      networkSwitchCancelled: "ネットワーク切り替えがキャンセルされました",
      networkConfigNotFound: "ネットワーク設定が見つかりません {chainId}",
      signatureCancelled: "署名がキャンセルされました",
      connectionFailed: "ウォレット接続に失敗しました",
      accountSwitched: "ウォレットアカウントが切り替わりました、再接続してください",
      connectionTimedOut: "接続がタイムアウトしました、再試行してください",
      loginSuccess: "ログイン成功",
      logoutSuccess: "ログアウトしました",
      switchNetwork: "入金を試みる前に、ウォレットで{chainName}に切り替えてください",
      wrongChain: "現在のネットワークはサポートされていません。{chainName}に切り替えてください",
      switchingNetwork: "ネットワークを切り替え中...",
      switchNetworkFailed: "ネットワーク切り替えに失敗しました。ウォレットで手動で{chainName}に切り替えてください"
    }
  },
  market: {
    title: "市場",
    banner: {
      title: "イベント契約",
      desc: "オンチェーンの収益ポテンシャルを解放"
    },
    tabs: {
      main: "主要通貨",
      rise: "上昇率ランキング"
    },
    types: {
      crypto: "暗号通貨",
      stocks: "米国株",
      forex: "外国為替",
      commodities: "コモディティ",
      favorites: "お気に入り"
    },
    headers: {
      pair: "取引ペア",
      price: "最新価格",
      change: "本日の変動率"
    },
    loading: "読み込み中...",
    loadingMore: "さらに読み込み中...",
    noMoreData: "これ以上データはありません"
  },
  notice: {
    loginRequired: "お知らせを見るにはログインしてください",
    empty: "お知らせはありません",
    unpublished: "公開終了",
    title: "お知らせ",
    helpCenter: "ヘルプセンター",
    noticeDetail: "お知らせ詳細",
    viewDetail: "詳細を見る",
    pdfViewer: "PDFビューア",
    videoPlayer: "動画プレーヤー",
    imageViewer: "画像ビューア",
    documentViewer: "ドキュメントビューア",
    clickToViewPdf: "クリックしてPDFを表示",
    clickToViewDocument: "クリックしてドキュメントを表示",
    openInBrowser: "ブラウザで開く",
    tryingViewer: "方法 {current}/{total} を試しています",
    pdfLoadFailed: "PDFプレビューの読み込みに失敗しました。ダウンロードしてご覧ください",
    downloadPdf: "PDFをダウンロード",
    defaultCategory: "Notice"
  },
  trade: {
    title: "イベント契約",
    nextRound: "次のラウンド",
    posCurrent: "現在",
    aiThenPrefix: '当時の AI：',
    aiUnlinked: 'AI 未連携',
    aiNotRecorded: '未記録',
    insuranceLabel: "保険",
    insuranceNotSelected: '未選択',
    insuranceInactive: "未生效",
    insuranceTypeNone: "未生效",
    insuranceTypeEvent: "通常保険に加入済み",
    insuranceTypeEventShort: "通常保険",
    insuranceTypeAi: "AI保険に加入済み",
    insuranceTypeAiShort: "AI保険",
    insuranceTypeConverted: "この注文は通常保険に変更済み",
    insuranceTypeUnknown: "保険状態を確認中",
    inProgress: "進行中",
    estimatedPnl: "推定損益",
    settlementConfirming: "決済中、結果を確認しています",
    balanceSyncing: "残高を同期中",
    pendingReview: "確認待ち",
    connecting: "接続中...",
    connectWallet: "接続",
    orderDetail: {
      title: "注文詳細",
      orderId: "注文ID",
      symbol: "銘柄",
      interval: "期間",
      direction: "実際の方向",
      aiDirection: "当時の AI",
      openTime: "開設時間",
      settleTime: "満了時間",
      settledAt: "決済時間",
      openPrice: "建値",
      closePrice: "決済価格",
      stake: "元本",
      premium: "保険料",
      netProfit: "純損益",
      status: "ステータス",
      orderSource: "注文元",
      converted: "保険転換",
      notRecorded: "未記録",
      copied: "注文IDをコピーしました",
    },
    orderStatus: {
      CREATED: "作成済み",
      ACCEPTED: "受付済み",
      CLOSED: "クローズ",
      FUNDS_LOCKED: "資金ロック中",
      AWAITING_SETTLEMENT: "決済待ち",
      PROCESSING: "処理中",
    },
    insuranceBalanceInsufficient: "保険口座の残高不足",
    mainBalanceInsufficient: "メイン口座の残高不足",
    insuranceBalanceRequired: "保険口座の残高が不足しているため、保険を有効にできません",
    insuranceRulesUnavailable: "保険料ルールの準備ができていないため、保険を有効にできません",
    insuranceMainRequired: "メイン口座の残高が不足しているため、保険を有効にできません",
    preferenceLoading: "保険設定を読み込み中",
    preferenceLoadFailed: "保険設定の読み込みに失敗しました。再試行してください",
    preferenceSaveFailed: "保険設定の保存に失敗しました。再試行してください",
    preferenceSessionEndedSaveFailed: "ラウンドが終了したため、オフ設定が保存されませんでした",
    premiumEstimate: "予想保険料 {premium} JOULE（5-10%）",
    premiumShortfallHint: "保険口座が {amount} JOULE 不足しています",
    premiumEstimateUnavailable: "まだ保険料を見積もれません",
    premiumBoundEstimate: "バインド済み戦略の予想保険料 {premium} JOULE",
    insuranceConfirmTitle: "保険料の確認",
    insuranceConfirmBody: "プレビュー保険料 {premium} JOULE。プレビュー結果が最終です。確認後に提出してください。",
    actions: {
      rise: "ロング",
      fall: "ショート",
      buy: "購入",
      sell: "売却"
    },
    holdings: {
      current: "ポジション",
      history: "取引履歴",
      currentCount: "保有注文数 {n}",
      empty: "ポジションなし",
      historyEmpty: "取引履歴なし"
    },
    position: {
      openPrice: "参入価格",
      closePrice: "決済価格",
      profitLoss: "損益",
      countdown: "決済まで",
      calculating: "計算中...",
      settled: "決済済み",
      settling: "決済中",
      active: "アクティブ",
      settledAt: "決済時刻"
    },
    modal: {
      amountPlaceholder: "金額を入力"
    },
    pairSelector: {
      title: "取引ペアを選択",
      searchPlaceholder: "コインを検索"
    },
    errors: {
      dataNotReady: "データを読み込み中です、お待ちください"
    },
    marketPause: {
      default: "現在取引できません。しばらくしてから再試行してください",
      lastPriceStreamWarming: "最新価格の準備中です。しばらくしてから再試行してください",
      marketWarming: "市場の準備中です。しばらくしてから再試行してください",
      recovering: "相場を復旧中です。しばらくしてから再試行してください",
      clockNotSynced: "サーバー時刻が未同期です。しばらくしてから再試行してください",
      symbolUnavailable: "この取引ペアはまだ開放されていません"
    },
    toasts: {
      connectSuccess: "接続に成功しました",
      connectCancelled: "接続をキャンセルしました",
      connectFailed: "接続に失敗しました"
    },
    openPriceLabel: "始値",
    secondsUnit: "s",
    amountLabel: "金額",
  },
  exchange: {
    title: "フラッシュスワップ",
    from: "から",
    to: "へ",
    balance: "残高",
    all: "すべて",
    placeholder: "入力してください",
    fee: "手数料",
    minAmount: "最低スワップ額：{amount} {symbol}",
    button: "スワップ",
    tradeButton: "取引",
    paymentCurrency: "支払い通貨",
    estimatedGasFee: "推定ガス料金",
    gasPaymentNote: "GetGas残高でガス料金を支払います",
    slippage: "スリッページ",
    auto: "自動",
    approximately: "約",
    minReceived: "最小受取額",
    exchangeRate: "交換レート",
    finalAmount: "最終金額",
    confirm: "確認",
    swapSuccess: "フラッシュスワップ成功！",
    swapping: "スワップ中...",
    confirmTitle: "操作の確認",
    confirmContent: "この操作を実行してもよろしいですか？",
    toasts: {
      fetchFailed: "資産の取得に失敗しました",
      enterValidAmount: "有効な金額を入力してください",
      minAmount: "最低スワップ額は{amount} {symbol}です",
      swapSuccess: "スワップに成功しました",
      requestFailed: "リクエストに失敗しました",
      insufficientBalance: "残高不足、スワップできません",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "Joule → USDT 手数料 {fee}",
    configLimits: "手数料 {fee} · 控除前価値上限 {min}–{max} U",
    unlimited: "制限なし",
    quoteFailed: "見積を取得できません。再試行してください"
  },
  globalNode: {
    title: "グローバルノード"
  },
  eventInsurance: {
    title: "イベント契約保険",
    availableBalance: "利用可能残高（USDT）",
    fundTransfer: "資金振替",
    fundHistory: "資金履歴",
    type: "タイプ: ",
    all: "すべて",
    transfer: "振替",
    fundTransferTitle: "資金振替",
    currency: "通貨",
    from: "から",
    to: "へ",
    availableAccount: "利用可能口座",
    contractInsuranceAccount: "契約保険口座",
    pleaseEnter: "入力してください",
    confirmTransfer: "振替を確認",
    insufficientBalance: "残高不足",
    transferSuccess: "振替成功",
    transferFailed: "振替失敗",
    transferring: "振替中...",
    noRecords: "記録がありません",
    selectAccount: "アカウントを選択",
    cannotTransferToSameAccount: "同じアカウントに振替できません",
    cannotTransferContractAccount: "契約アカウントの振替はサポートされていません",
    contractAccount: "契約アカウント (TAKER)",
    rulesTab: "概要",
    agreementTab: "完全な契約",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "一.イベント契約予測ルール",
      eventOpen: {
        title: "1. 保険の有効化",
        points: [
          "保険ON時、注文額と口座残高の比率で保険料：残高の10%以下→15%、超過→20%。",
          "保険口座残高不足の場合、保険は無効"
        ]
      },
      eventLimit: {
        title: "2. 注文上限",
        points: [
          "1注文あたり上限は 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. 補償権利ルール",
        ok: [
          "補償の50%は個人エアドロップ枠へ。累計50 USDで計算ノード1つ",
          "30%はコミュニティ枠へ（VIP規則）。累計50 USDで計算ノード1つ"
        ],
        fail: [
          "全元本を失い、予測終了"
        ]
      },
      eventPool: {
        title: "4. イベント保険プール補償：",
        points: [
          "プール日次資産の2%相当のPANTAを適格ユーザーのノード加重でエアドロップ",
          "日次エアドロップがPANTA換算50 USDに達するとノードが1つ減少"
        ]
      },
      eventProfit: {
        title: "5. 損益ルール",
        points: [
          "的中：元本100% + 利益(80%)",
          "外れ：全元本を失い予測終了"
        ]
      },
      aiGroup: "二.AIイベント契約予測ルール",
      aiFirst: {
        title: "1. 初回注文は手動入力が必要"
      },
      aiOpen: {
        title: "2. 保険の有効化",
        points: [
          "保険ON時、ポジション額の5%〜10%を保険料として支払う",
          "保険口座残高不足の場合、保険は無効"
        ]
      },
      aiLimit: {
        title: "3. 注文制限",
        points: [
          "金額はポジション表に従い、方向はAI予測と一致必須",
          "表に従わない場合は通常イベント契約予測に切替",
          "連続8敗で規定割合の補償権利",
          "勝ち注文でシーケンスを第1手にリセット"
        ]
      },
      table: {
        level: "口座レベル",
        order1: "第1手",
        order2: "第2手",
        order3: "第3手",
        order4: "第4手",
        order5: "第5手",
        order6: "第6手",
        order7: "第7手",
        order8: "第8手"
      },
      claimOk: "補償条件を満たす",
      claimFail: "補償条件を満たさない",
      claimFailWhen: "補償不可の場合：",
      claimPrereq: "補償前提：",
      aiClaim: {
        title: "4. 補償権利メカニズム",
        prereq: [
          "保険ON",
          "方向がAIと一致",
          "金額/順序が表通り",
          "完全決済条件を満たす"
        ],
        ok: [
          "現金補償 = 累積損失 × 90%"
        ],
        fail: [
          "全元本を失い予測終了"
        ]
      },
      aiProfit: {
        title: "5. 利益ルール",
        points: [
          "的中：元本100% + 利益80%",
          "外れ：全元本喪失、終了または補償適用"
        ]
      }
    },
    rulesContent: "PANTA Market イベント契約取引保障計画保険契約\n\n【重要なお知らせ】本サービスをご利用になる前に、契約の全文を必ず注意深くお読みいただき、十分にご理解ください。ユーザーが「保険スイッチ」をオンにした時点で、本契約および添付内容を十分に読み、理解し、受諾したものとみなされます。契約が法的拘束力を有することを確認し、厳格に遵守することに同意したものとみなされます。同意されない場合は、直ちに本保障計画の利用を中止してください。\n\n第1条：契約総則および適用範囲\n\n1.1 本契約は、PANTA Market 内の「イベント契約予測」「AIイベント契約予測」の2つの機能について、参加方式、注文成立、手数料、結果判定、資金決済、条件付き賠付および関連ノード権益およびイベント予測機能を説明するものです。2つの商品はそれぞれ専用条項が適用され、一方の商品の料率、賠付条件またはノード規則を他方の商品にそのまま適用することはできません。\n1.2 イベント契約予測は、ユーザーが事前に明示されたイベントおよびその選択可能な結果について判断し、JOULE を使用して提出し注文を作成する機能です。最終的な適格損失は、承認された規則に従い個人またはコミュニティチームノード限度額を生成できます。当該限度額は即時の現金賠付ではありません。AIイベント契約予測は、ユーザーがシステムが提供する有効な AI 予測方向シグナルを参照し、選択した方案の固定金額および順序に従って逐次確認・参加して注文を作成する機能です。同一の適格シーケンスの8件の注文が完全に決済され、すべて損失であり、かつその他の明示条件を同時に満たす場合、適格元本合計の90%を JOULE で賠付します。AI シグナルは結果の保証ではなく、条件付き賠付もすべての支出をカバーするものではありません。\n1.3 本契約、対応する商品のバージョン化パラメータ、具体的なイベント規則およびユーザー確認ページは、共同して完全な規則を構成します。ページは既に承認されたパラメータのみを表示でき、「ページを基準とする」ことで重要条件の欠落を代替することはできません。文書間に矛盾が生じた場合、影響を受ける新規取引を停止し、説明、検証および是正を行うものとし、事後に一方的にユーザーに不利な解釈を選択して既存注文を処理することはできません。\n1.4 本プロジェクトは、実資産、イベント予測、条件付き賠付および保険の名称、チーム報酬、交換および資金プールを含み、リスク管理・コンプライアンス審査を省略できる商品ではありません。各機能の法的性質、許可、提供可能地域、ユーザー資格、AML、消費者保護およびデータ処理要件は、実際のサービス範囲に応じて専門的な検証を完了する必要があります。免責条項は必要な許可、資金配置および統制措置に代わるものではなく、本稿は特定の国の法律を前提とせず、商品が既に合法的に運営許可を得ていると認定するものでもありません。\n\n第2条：用語および資金状態\n\n2.1 JOULE は、本商品設計において予測元本、保険料および AI 賠付計量に使用する単位です。PANTA は、ノード権益分配等の業務に使用する資産単位です。USDT 等値は、一部の限度額および価値測算に使用する計量基準です。三者は混用できず、内部数値表示は固定為替レートで法定通貨に即時交換できることを意味せず、オンチェーン資産移転が完了したことを意味するものでもありません。この説明は、既に法令・契約に従って形成された資産権益または支払義務を取消するものではありません。\n2.2 注文元本とは、ユーザーが某件の注文において実際に確認し、システムが受諾した JOULE 金額であり、保険料を含みません。保険料とは、当該注文に適用される規則に基づき計算される費用です。凍結総額は通常、元本と保険料の合計であり、別途費用がある場合は事前にそれぞれ開示し、決済時に未確認の料金を追加することはできません。\n2.3 利用可能残高とは、現在のアカウント規則の下で新規操作に使用できる残高です。凍結残高とは、受諾された注文または承認された業務のために予約され、一時的に他の操作に使用できない残高です。予想収益、審査待ち賠付、ノード限度額および未入金分配は、利用可能残高に含まれません。残高表示には資産名称を明記し、異なる資産数量を直接合算することはできません。\n2.4 AI シーケンスとは、ユーザーが同一の確定済み方案に対し、第1件から規則に従って連続する業務記録です。現在のステップ、注文結果および資格証拠はサーバー側で維持されます。通常のネットワーク切断またはアプリ終了は、シーケンス業務の終了を構成しません。リセットとは、本契約に定める条件を満たした後、旧シーケンスを終了することです。\n2.5 算力ノード限度額とは、最終的な適格損失に基づき規則に従って累計し、ノード生成に使用する USDT 等値の記帳単位です。ノードとは、後続の権益分配に参加する資格記録であり、即時の現金、入金済み PANTA ではなく、名称のみで取引、ステーキングまたは自由譲渡可能なオンチェーン NFT となるものでもありません。\n2.6 規則スナップショットとは、注文またはシーケンス確認時に保存される規則バージョン、パラメータ、金額、価格根拠、条項および関連証拠です。新バージョンのリリースは旧スナップショットを上書きできません。サーバー側記録は操作状態の検証に使用されますが、ユーザーは他の証拠を提供して再審査を申請でき、記録がプラットフォームに保存されているという理由のみで合理的な異議を排除することはできません。\n\n第3条：利用資格および契約確認\n\n3.1 プラットフォームは、承認されたサービス地域、年齢範囲および適合性範囲内のユーザーにのみ、該当する機能を提供できます。正式版では、本人確認要件、商品利用可能範囲および制限理由を明確にする必要があります。ユーザーのウォレットが接続済み、画面が表示されている、または口座に残高があるという理由のみで、すべての商品への参加資格を認定することはできません。\n3.2 ユーザーは、本人が権限を有するアカウントおよび資産を使用するものとし、なりすまし、他人のアカウントの無断使用、資格資料の偽造、シグナルまたは結果証拠の操作を行ってはなりません。プラットフォームが追加検証を必要とする場合、必要な資料と業務目的を説明するものとし、新規参加への制限と既存注文の履行処理はそれぞれ説明する必要があります。\n3.3 ユーザーは、注文前に元本、保険料、可能性のある追加費用、予測オプション、最悪の損失、決済条件、判定ソースおよび紛争経路を閲覧できるものとします。プラットフォームは明確な確認手順を提供し、デフォルト同意、隠れた費用、自動金額切替または繰返し操作の催促によって、ユーザーの真の確認に代えることはできません。\n3.4 AI シグナル、過去の結果、例示収益、ノードプール規模および他者の権益記録は、いずれも将来の結果の約束を構成しません。ユーザーは、受諾済み注文の元本および関連保険料を失う可能性があり、ノード権益もプール残高、有効ウェイト、価格および処理状態の影響を受ける可能性があります。ユーザーは、特定の例示を本人の固定収益または確定回収期間とみなしてはなりません。\n\n第4条：イベント契約予測規則\n\n4.1 ユーザーは AI シーケンスを開始する前に、利用可能な方案、実行ポジション元本、予想保険料、合計資金需要、シグナル有効期間、60秒決済規則および90%賠付条件を確認する必要があります。新シーケンスは第1件からのみ開始でき、シーケンス進行中に方案を切り替えることはできません。ユーザーは、ステップ飛ばし、金額変更または並行未決注文によって新たな適格シーケンスを組み合わせることはできません。ユーザーがイベント結果を選択し JOULE 元本を入力した後、プラットフォームは承認済みポジション基数に基づき保険料を計算します。現在の設計：元本がポジション基数の10%以下の場合、保険料は元本の15%。ポジション基数の10%を超える場合、保険料は元本の20%。ちょうど10%の境界の場合は15%を適用します。\n4.2 AI シグナルは、対象、方向、時間、有効期間および識別可能なシグナル番号を表示する必要があります。ユーザーは注文時に、当時有効なシグナルと一致する方向を確認しなければなりません。シグナルが待機または再接続中に更新された場合、再検証が必要です。期限切れシグナルはクライアントキャッシュで継続使用できません。AI シグナルの採用は、プラットフォームまたはアルゴリズムが将来の結果を知っていることを意味しません。過去の正確率、デモ記録および予測説明は、当該注文の結果保証にはなりません。プラットフォームは「必勝」「確実利益」または「誤っても無損失」等の表現で、実際の元本、保険料および賠付条件に代えることはできません。\n4.3 各イベントは、名称、事実説明、選択可能な結果、開始および締切時点、タイムゾーン、参加限度、結果判定基準、主要および予備証拠ソース、利益計算、最悪損失、取消または延期規則および異議申立手続を独立して明示する必要があります。曖昧なイベント、判定基準の欠落、または重要な経済パラメータが未承認のイベントについては、実取引注文を開放してはなりません。プラットフォームは受注時に、イベントが依然として開放状態であること、サーバー時間が締切時点より前であること、オプションおよびバージョンが有効であること、ユーザー資格および限度が充足していること、残高が十分であることを再確認する必要があります。締切判断は、ユーザーの端末時間またはクリック時にクライアントが依然としてカウントダウンを表示しているかどうかを基準としません。\n4.4 元本および保険料の凍結成功、注文受諾後、プラットフォームは受諾時間および約定決済時点を返します。当該時点はサーバー受諾時間に60秒を加算して計算し、ユーザーがページを開いた時点、シグナルを受信した時点またはボタンをクリックした時点から計算しません。ネットワーク遅延は、既に確定した判定基準を短縮または延長しません。60秒は約定の結果判定时点を示し、クライアントカウントダウンがゼロになる同一瞬間に資金入金が完了することを約束するものではありません。時点到達後、約定ソースから結果証拠を取得する必要があります。証拠なし、ソース異常または結果衝突の場合、決済待ちを維持し状態を説明し、自動的に損失として記録することはできません。\n4.5 現在の有効シーケンスであり、規則が明確に表示され、未決注文がない状態において、ユーザーが実際に有効シグナルと不一致の方向、または現在の固定ステップと不一致の金額を提出した場合にのみ、拒否および旧シーケンス終了のリセット設計が適用されます。具体的な理由、影響を受けるシーケンスおよび次に実行可能な操作を表示し、履歴を保存する必要があります。リセット後、次回は第1件から新シーケンスを構築でき、旧シーケンスの既損注文と新シーケンスの注文を連結して8連敗を計算することはできません。旧シーケンスで完了した損益は保持され、自動的に90%賠付を受けるものではありませんが、プラットフォームエラー、誤ったリセットまたはその他の紛争について再審査を申請する権利を妨げるものではありません。\n4.6 拒否された違反リクエスト自体は成立せず、新規元本損失、保険料または損失ノードを生じません。原材料における違反損失をノードに転換する表現は、まだ実行可能な規則を形成しておらず、拒否注文に虚偽の損失または補償を創出することはできません。\n4.7 ユーザーが後続ステップの開始を一時停止しても、8連敗が既に形成されたことを意味しません。未完了シーケンスは、損失件数の比率に基づく90%賠付を請求することはできません。シーケンスの自主終了、長期滞留および復旧期限については、正式な規則確認が必要であり、未開示の失効時間を独自に設けることはできません。通常の退出およびネットワーク切断を自主的放棄と解釈することはできません。同一シーケンスが以下の4条件を同時に満たす場合にのみ、現在の設計に基づき90% JOULE 賠付を計算します：各件の保険メカニズムが有効にオンであり、当該元本および保険料が実際に凍結成功；各件の方向が受諾時の有効 AI シグナルと一致；各件の元本およびステップ順序が確定方案に適合；8件すべてが完全決済され、結果がすべて適格損失。賠付金額は、適格8件の参加元本合計に90%を乗じたものであり、JOULE で計量・支払いします。保険料は当該90%基数に含まれません。賠付を全支出の90%返還と直接表現することはできず、USDT、現金または PANTA に自動換算されるものでもありません。他資産の交換には、独立した規則および承認が必要です。\n4.8 賠付資格の成立と支払成功は2段階です。資格を有するが資金不足、帳簿異常または適用制限がある場合、支払待ち義務および明細を保持し、処理中または明確な保留理由を表示した後、法令・契約に従って処理するものとし、支払困難をユーザーが資格不適合であると書き換えることはできません。\n4.9 賠付は、当該シーケンスの唯一の記録として1回のみ実行します。支払成功だが応答が消失した場合、後続の照会および再試行は元の結果を返し、重複支払いを行いません。支払失敗は、真の未完了状態を維持する必要があり、ユーザーに新シーケンスの作成または再注文によって元の賠付を「活性化」するよう要求することはできません。同一シーケンスにおいて、事前確認メカニズムにより各件が異なる料率を採用できる場合、各件のスナップショットを保持し実際の費用を累計する必要があり、単純に現在の某一料率ですべての過去注文を再計算することはできません。既に確定したシーケンスに影響する料率メカニズムの変更は、まず適用範囲を明確にする必要があり、新ページを通じて遡及的にコストを増加させることはできません。\n4.10 資産最小単位、精度、逐次丸め方法および端数処理は、リリース前に確定し一貫して維持する必要があります。ページ表示のための四捨五入は、帳簿明細を変更してはなりません。計算例示の精度は、既に承認された支払精度ではありません。手数料、価格差および端数を、統合表示方式で隠すことはできません。\n\n第5条：システムサービス\n\n5.1 ネットワーク切断またはリクエストタイムアウト：ユーザーはまず元注文を照会し、プラットフォームは受諾済み、明確拒否または依然確認待ちの実際状態を返します。元結果が不明な場合、重複支払いを誘導してはなりません。後続確認で未受諾と確定した場合にのみ、現在有効な規則に従い新リクエストを再度確認できます。\n5.2 シグナルまたは見積期限切れ：旧リクエストを拒否し、理由を表示して内容を再取得します。新方向、新金額または新費用を黙って置換してはならず、期限切れを自動的に AI 違反リセットとみなしてはなりません。旧リクエストが既に受諾されている場合、当該スナップショットに従い履行します。\n5.3 結果または価格異常：影響を受ける判定、評価または分配を一時停止し、状態、影響範囲および照会経路を提供します。結果欠落を失敗損失として記録することはできず、異常評価を損失基数の拡大に使用することはできません。予備ソースの変更は、事前に公表されたソース順序および異常規則に従う必要があります。\n5.4 帳簿差異または外部取引状態不明：まず元記録および外部受領を検証し、不可逆アクションを重複送信しません。失敗確定後、相应規則に従い解凍または再試行します。不明は返金完了を意味しません。完了したユーザー資金操作と未完了の後続購入、プール入金ステップはそれぞれ表示する必要があります。\n5.5 資金不足：不足を拡大しうる関連新規業務を停止し、既に形成された義務を保持し、処理待ち状態を通知し、承認された方案に従って処理します。入金完了を偽造したり、ユーザー利用可能残高を負数に変更したり、未告知の追加料金で差額を埋めることはできません。\n5.6 リスク制限：プラットフォームは、正式承認され適切に開示された規則に従い、必要な検証または制限を行うことができますが、新規注文制限、支払遅延および資格取消を区別する必要があります。制限は、過去の勝敗または既に満たされた経済条件を自動的に書き換えることはできず、例外適用には事実と根拠が必要であり、利用可能な再審査経路を提供する必要があります。\n5.7 保守、サービス停止または特定商品の終了時も、過去注文、賠付、紛争および照合可能な記録については処理手配が必要です。ユーザーが新規取引を追加できないことは、既存残高、支払うべき賠付または異議権が消失することを意味しません。新規業務スイッチをオフにすることは、すべての過去照会および履行プロセスを同時に閉じることになってはなりません。\n\n第6条：免責条項\n\n以下の事由により生じた損失について、サービスは賠償責任を負いません。\n6.1 戦略不遵守：本プラットフォーム標準ポジション管理規定から逸脱するすべての行為\n6.2 極端な市場条件：取引所の麻痺、流動性枯渇、市場操作による損失\n6.3 システム・運営リスク：ユーザーの端末故障、操作ミス、アカウント盗用による損失\n6.4 政策・コンプライアンスリスク：法令、規制命令の変更による取引中断または禁止\n6.5 内在トークンリスク：JOULE 時価総額の大幅下落または崩壊により、証拠金および決済通貨機能に影響が生じる場合\n6.6 詐欺・悪意行為：詐欺、マネーロンダリング、市場操作またはその他の違法行為\n6.7 不可抗力：不可抗力による本プラットフォームシステム障害\n\n第7条：リスク開示\n\nユーザーは、以下のリスクを十分に理解し、受諾することを確認します。\n7.1 元本・利益非保証：本計画は一部の損失のみを賠償し、元本安全または利益を絶対に保証しません\n7.2 戦略依存リスク：保障効果は、戦略の厳格な遵守に完全に依存します\n7.3 流動性・ロックリスク：賠償資金が資産管理口座に入る場合、投資リスクおよびロック期間があり、資金流動性に影響を与える可能性があります\n7.4 第三者リスク：依存する取引所の運営、セキュリティおよび価値変動リスク\n7.5 規制不確実性リスク：本プラットフォームは、グローバル規制の不確実性および停止リスクに直面します\n7.6 技術セキュリティリスク：スマートコントラクトの脆弱性、ハッキング等による資産損失リスクを含みます\n\n第8条：契約変更・終了および紛争\n\n8.1 契約変更：プラットフォームは、法令または運営必要に応じ本契約を改定する権利を留保し、重大な変更はプラットフォーム公告により通知します\n8.2 契約終了：ユーザーはいつでも保障スイッチをオフにしてサービスを終了できます。ユーザーが契約に違反した場合、プラットフォームは一方的に終了できます。法律または政策の理由により、本計画が終了する場合があります\n8.3 紛争解決：本契約に起因する紛争は、まず友好的協議により解決するものとし、協議不成立の場合、指定仲裁機関または裁判所に提出します\n\n【最終確認】「保険スイッチを有効にする」ことが、本契約の全文に拘束されることを確認する唯一かつ最終的な方法であることを理解し、同意します。独立した判断に基づき決定してください。",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "接続",
    inputPlaceholder: "アドレスを入力",
    bind: "バインド",
    binding: "バインド中",
    tip: "ヒント：ウォレット接続に問題がある場合は、手動でウォレットアドレスを入力してバインドしてください"
  },
  loginModal: {
    title: "PANTA MARKETにログイン",
    connectWallet: "接続",
    connecting: "接続中...",
    alreadyConnected: "接続済み",
    tip: "ヒント：ウォレット接続に問題がある場合は、手動でウォレットアドレスを入力してバインドしてください",
    inputLabel: "ウォレットアドレスを入力",
    inputPlaceholder: "0x234d456f6798...",
    bind: "バインド",
    binding: "バインド中",
    bindSuccess: "バインド成功",
    bindSuccessHint: "バインド成功、再度ログインしてください",
    bindFailed: "バインド失敗",
    noAuthCode: "認証コードがありません",
    invalidAddress: "無効なウォレットアドレス形式",
    confirmTitle: "バインドの確認",
    confirmWarning: "以下のアドレスがあなたのウォレットアドレスであることを慎重に確認してください。バインド後は変更できません",
    addressLabel: "ウォレットアドレス",
    cancel: "キャンセル",
    confirm: "バインドを確認",
    loginSuccess: "ログイン成功",
    openWalletApp: "{wallet}を開く",
    openWalletConnect: "{wallet}を開いて接続",
    openWalletSign: "{wallet}を開いて署名",
    returnToBrowser: "完了後、このページに戻ってください",
    loginStepLabel: "ステップ {step}/2",
    stepConnectTitle: "ウォレットを接続",
    stepConnectHint: "ウォレットで接続を承認し、このページに戻ってください",
    stepConnectHintWithOpen: "下のボタンでウォレットを開き、接続を承認してから戻ってください",
    stepSignTitle: "署名してログイン",
    stepSignHint: "ウォレットでログインメッセージに署名してください（資産は移動しません）。完了後に戻ってください",
    stepSignHintWithOpen: "あと一歩：下のボタンでウォレットを開き、ログインメッセージに署名してください",
    waitingWalletHintShort: "自動で開かない場合は、下のボタンでウォレットを開いてください",
    retryLogin: "ログインを再試行",
    networkRequired: "ネットワークを切り替えてください",
    networkRequiredHint: "{chain} に切り替えてから、このページに戻って再試行してください",
    switchingNetwork: "ネットワーク切替を確認",
    switchingNetworkHint: "ウォレットで {chain} への切替を承認してください",
    signatureRequired: "署名してログイン",
    signatureHint: "ウォレットで署名してください。資産は移動しません",
    verifyingLogin: "検証中",
    verifyingHint: "しばらくお待ちください",
    connectFailed: "接続が完了していません。再試行してください",

    waitingWalletReturn: "ウォレットで承認後、このページに戻ってください",
    waitingWalletHint: "ウォレットで承認してください。完了後に自動で戻ります"
  },
  walletProfile: {
    title: "プロフィール",
    address: "アドレス",
    accountName: "アカウント名",
    inviteCode: "招待コード",
    deactivateAccount: "アカウント削除",
    logout: "ログアウト",
    switchAccount: "アカウント切替",
    confirmLogout: "ログアウトしてもよろしいですか？",
    loggingOut: "ログアウト中...",
    confirmSwitch: "アカウントを切り替えてもよろしいですか？現在のアカウントはログアウトされます",
    developing: "開発中",
    addressCopied: "アドレスをコピーしました",
    inviteCodeCopied: "招待コードをコピーしました"
  },
  aiPrediction: {
    stakeAutofill: "AI補助",
    stakeAutofillWarning: "補助のみです。推奨金額が誤る場合があるため、注文前にご確認ください。通信遅延が 800ms を超えた場合、検出失敗・期限切れ時は自動入力を一時停止し、復帰後に再開します。手動注文には影響しません。",
    stakeAutofillUnavailable: "通信が不安定、または遅延が 800ms 超のため、まだ有効にできません",
    stakeAutofillPaused: "通信不安定のため自動入力を一時停止中。金額を手動入力してください",
    insuranceSyncing: "保険ステップを同期中…",
    predictionBuffer: '次の予測を準備中',
    scheduleResultPending: '今回の結果を再取得中',
    title: "AI予測",
    bookingTitle: "AIセッション予約",
    bookingExpand: "展開",
    bookingCollapse: "閉じる",
    bookingNextSystem: "システムの次場 · SGT",
    bookingNextMine: "次の予約",
    bookingNone: "なし",
    bookingStartingSoon: "予約したセッションがまもなく開始します",
    bookingToday: "今日",
    bookingTomorrow: "明日",
    bookingTimezone: "SGT",
    bookingQuota: "残り参加 {remaining}/{dailyLimit} 回",
    bookingSeats: "{occupied}/{capacity} 人",
    bookingEmpty: "利用可能なセッションがありません",
    bookingWaiting: "現在の操作が終わると自動入場します",
    bookingEnded: "終了",
    bookingJoin: "この場に参加",
    bookingReserve: "予約",
    bookingJoined: "入場済み",
    bookingReserved: "予約済み",
    bookingFull: "満員",
    bookingConfirm: "予約を確認",
    bookingWarning: "予約成功で当日1回分が消費され、不参加でもカウントされます。",
    bookingQuotaExhausted: "当日の参加枠を使い切りました",
    bookingUnavailable: "現在予約できません",
    bookingFailed: "予約に失敗しました。更新して再試行してください。",
    aiPool: "AI保険プール",
    countdown: "カウントダウン",
    expectedProfit: "予想利益",
    active: "アクティブ",
    aiAnalysis: "AIスマート上昇/下落確率分析",
    updateTime: "更新時間",
    probabilityUp: "上昇確率",
    probabilityDown: "下落確率",
    startPrediction: "予測開始",
    predicting: "予測中...",
    stayOnPageHint: "このページを離れないでください。離れると予測結果が失われる場合があります。",
    userInfo: "ユーザー情報",
    predictCount: "予測回数",
    freeCount: "無料予測回数",
    openTime: "開始時間: {time1}",
    up: "上昇",
    down: "下落",
    notConnected: "未接続",
    count: "回数",
    learnMore: "詳細を見る",
    calculating: "計算中...",
    settled: "決済済み",
    loginFirst: "先にログインしてください",
    sessionSyncing: "同期中",
    actions: {
      rise: "ロング",
      fall: "ショート"
    },
    holdings: {
      current: "ポジション",
      history: "履歴",
      empty: "ポジションなし",
      historyEmpty: "履歴なし",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "特権購入",
      description: "30回のAI予測を購入",
      upgradeAmount: "アップグレード金額",
      balance: "利用可能残高",
      cancel: "Cancel",
      confirm: "確認",
      purchasing: "購入中...",
      purchaseSuccess: "購入成功",
      purchaseFailed: "購入失敗",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "AI予測開始失敗",
      description: "AI予測回数が0です。現在AI予測機能を使用できません。購入後に続けてください。",
      cancel: "キャンセル",
      confirm: "AI予測を購入"
    },
    toasts: {
      predictionFailed: "予測失敗",
      predictionSuccess: "予測完了",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "分析中...",
    insurance: "保険",
    insuranceOn: "有効",
    insuranceOff: "無効",
    aiLabel: "AI",
    lookLong: "強気",
    lookShort: "弱気",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "このラウンドに従う",
    scheduleBinding: "シグナルを紐付け中...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "参入価格",
    settledAt: "決済時刻",
    ordinaryInsuranceTitle: "この注文は通常保険です",
    ordinaryInsuranceBody: "この注文は通常保険であり、AIラウンドの払戻しではありません。確認後、プレビュー保険料で送信します。",
    sessionConflict: "進行中のAI保険ラウンドがあります。通常保険を出す前に復旧するか終了してください",
    conversionTitle: "通常保険に切り替えますか？",
    conversionDesc: "本注文は通常保険に切り替わり、今回のAI保険ラウンドは終了します。これまでのAI連敗は補償されません。通常保険料 {premium} JOULE。",
    conversionConfirm: "切り替えて注文",
    stakeFromStrategy: "ポジションは戦略が指定",
    stakeTier: "等級 {tier}",
    stakeStep: "ステップ {step}",
    selfQuotaRemaining: "自主予測の残り回数：{remaining}/{limit}",
    followRoundProgress: "AI追従 · {current}/{total}ラウンド",
    followRoundsCompleted: "AI追従完了 · {current}/{total}",
    selfQuotaLoadingShort: "回数を読み込み中",
    selfQuotaLoginHint: "ログイン後に回数を確認",
    selfQuotaLoading: "回数を読み込み中です。しばらくしてから再試行してください",
    selfQuotaExhausted: "本日の無料自主予測回数を使い切りました。有料予測はまだ開放されていません"
  },
  positionModal: {
    title: "価格予測",
    insurance: "保険",
    long: "ロング",
    short: "ショート",
    balance: "残高",
    loading: "読み込み中...",
    confirm: "確認",
    processing: "注文処理中...",
    success: "注文が正常に完了しました！",
    insuranceOn: "保険が有効になりました",
    insuranceOff: "保険が無効になりました",
    operationFailed: "操作に失敗しました",
    balanceFetchFailed: "残高の取得に失敗しました",
    minAmount: "最小金額は 0.1 TAKER です",
    insufficientBalance: "残高不足、現在の残高: {balance} TAKER",
    createFailed: "ポジションの作成に失敗しました",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  assets: {
    insuranceFrozen: "保険凍結枠(JOULE)",
    available: "利用可能",
    deposit: "入金",
    withdraw: "出金",
    myAccountRecords: "マイアカウント記録",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "ベット凍結",
      WIN_PAYOUT: "取引利益",
      LOSS_SETTLEMENT: "取引損失",
      REFUND: "返金",
      INSURANCE_PREMIUM: "保険料支出",
      INSURANCE_PAYOUT: "保険給付",
      INSURANCE_TRANSFER_IN: "保険振替入金",
      INSURANCE_TRANSFER_OUT: "保険振替出金",
      NETWORK_DIFFERENTIAL: "取引級差報酬",
      NETWORK_PEER: "取引同格報酬",
      NETWORK_UNLOCK: "収益解除",
      EVENT_INSURANCE_PAYOUT: "算力ノード給付",
      EVENT_INSURANCE_PEER: "算力同格報酬",
      TRANSFER_IN: "入金",
      TRANSFER_OUT: "出金",
      PREMIUM_LOCK: "保険料ロック",
      PREMIUM_SETTLE: "保険料支出",
      PREMIUM_REFUND: "保険料返還",
      WEALTH_SUBSCRIPTION: "ファンド申込",
      SUBSCRIPTION_LOCK: "ステーキングロック",
      WEALTH_DAILY_REWARD: "ファンド日次利息",
      WEALTH_TEAM_REWARD: "ファンドチーム報酬",
      MATURITY_RELEASE: "満期元本返還",
      WEALTH_UNLOCK: "収益解除",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "取引損益",
      PREMIUM: "保険料",
      INSURANCE_PAYOUT: "保険給付",
      TEAM_REWARD: "チーム報酬",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "ファンド日次利息",
      UNLOCK: "収益解除",
      PRINCIPAL: "申込/元本返還",
      TRANSFER: "内部振替"
    },
    amountPendingReview: "金額を確認中",
    creditedSplit: "利用可能 {available} · 凍結 {frozen}",
    creditedSplitPending: "内訳を確認中",
    afterBalance: "変動後 利用可能{available} · 凍結{frozen}",
    unlockHint: "凍結→利用可能（新規収益ではない）",
    transferFromInsurance: "保険口座",
    transferFromMain: "主口座",
    all: "すべて",
    transfer: "振替",
    insuranceDeduction: "保険控除",
    insurancePayout: "保険支払い",
    noRecords: "記録なし",

    actions: {
      deposit: "入金",
      withdraw: "出金",
      exchange: "交換",
      transfer: "振替"
    },
    loginPrompt: {
      text: "先にウォレットを接続してください",
      button: "接続"
    },
    toasts: {
      connectFailed: "接続に失敗しました。もう一度お試しください"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Insurance",
    copyAccountShort: "コピー",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "コピー口座(JOULE)",
    copyTotalPnl: "コピー損益",
    transferSheet: {
      title: "振替",
      pairCopy: "取引/コピー",
      pairInsurance: "取引/保険",
      tradingAccount: "取引口座",
      copyAccount: "コピー口座",
      insuranceAccount: "保険口座",
      jouleHint: "JOULEのみ振替可能",
      submit: "送信",
      transferring: "振替中...",
      success: "振替成功",
      failed: "振替失敗、再試行してください",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "元本+予想収益",
    stakedPlusRewardTipTitle: "ステーキング元本 + 予想収益",
    stakedPlusRewardTip:
      "この数値はステーキング元本と予想総収益の合計です。",
    stakedPrincipalLabel: "ステーキング元本",
    stakedExpectedYieldLabel: "予想収益",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "ファンドチーム未支給報酬(PANTA)",
    fundTeamPaidPanta: "ファンドチーム支給済報酬(PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "推定エアドロップ額",
    cumulativeAirdropValue: "累計エアドロップ価値：{value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  appeal: {
    title: "資産回復支援",
    records: "提出記録",
    recordsTitle: "提出記録",
    noRecords: "提出記録がありません",
    submitTime: "提出時間",
    statusPending: "処理待ち",
    statusApproved: "承認",
    statusRejected: "却下",
    failedReason: "拒否理由",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "読み込み中...",
    walletAddress: "PANTA MARKETにバインドされたアドレス",
    address: "アドレス",
    walletAddressPlaceholder: "PANTA MARKETログインアドレスを入力",
    autoFill: "自動入力",
    depositAmount: "入金額",
    depositAmountPlaceholder: "入金額を入力",
    tokenType: "トークンタイプ",
    selectToken: "トークンを選択",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "送金時間",
    selectTime: "送金時間を選択",
    timeRangeHint: "2026年3月5日 00:00 から 3月11日 10:00（SGT）の間に発生した関連データ。",
    txHash: "HASH / TXID",
    txHashPlaceholder: "トランザクションハッシュを入力",
    txHashHint: "ブロックチェーンエクスプローラーで確認できます",
    uploadImages: "送金記録のスクリーンショット",
    uploadHint: "任意、最大9枚の画像をアップロード",
    addImage: "画像を追加",
    submit: "提出",
    submitting: "提出中...",
    submitSuccess: "提出が完了しました",
    submitFailed: "提出に失敗しました。再試行してください",
    uploadingImages: "画像をアップロード中...",
    uploadImagesFailed: "画像のアップロードに失敗しました",
    warningTitle: "重要なお知らせ",
    warningText: "提出された記録が検証に成功した場合、サブスクリプションパワーの5%が報酬として付与されます。虚偽の情報を提供した場合、アカウントが凍結されます。"
  },
  withdrawSheet: {
    title: "出金",
    balance: "残高",
    processing: "TAKER出金中...",
    success: "TAKER出金成功！",
    withdrawing: "出金中...",
    withdrawSuccess: "審査待ち",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "TAKER入金",
    depositTo: "入金先",
    spotAccount: "スポットアカウント",
    network: "ネットワーク",
    networkWarning: "BSC/BEP20ネットワークの入金のみサポートされています。他のネットワークの使用による資産損失は回復できません。",
    depositAddress: "入金アドレス",
    address: "アドレス",
    depositTAKER: "TAKER入金",
    recharge: "チャージ",
    rechargeAddress: "チャージアドレス",
    copy: "コピー",
    copySuccess: "コピー成功",
    loadingAddress: "チャージアドレスを取得中...",
    loadAddressFailed: "チャージアドレスの取得に失敗しました",
    clickToRetry: "クリックして再試行",
    generating: "生成中...",
    saveAndShare: "アドレスを保存して共有",
    generateSuccess: "生成成功",
    generateFailed: "生成失敗",
    more: "もっと",
    save: "保存",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "保存された画像",
    download: "ダウンロード",
    pleaseGenerate: "最初に画像を生成してください",
    downloadSuccess: "ダウンロード成功",
    saveSuccess: "保存成功",
    saveFailed: "保存失敗",
    needPermission: "アルバムに画像を保存する権限が必要です",
    pleaseUseDapp: "ウォレットを使用してDAppを開いてください",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "アカウントにログイン",
    inviteBanner: "友達を招待してチーム手数料を獲得",
    inviteCode: "招待コード",
    defaultName: "PANTA MARKET",
    logoutWallet: "ウォレット接続を解除"
  },
  teamDetails: {
    myReferrals: "私の紹介",
    currentLevel: "現在のレベル: {level}",
    nextLevel: "次のレベル",
    totalMembers: "直接紹介",
    validMembers: "有効メンバー",
    teamLevel: "チームレベル: {level}",
    tradeTeam: "トレードチーム",
    financeTeam: "ファイナンスチーム",
    teamMembers: "チームメンバー",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "{name}の直紹介",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "総収益",
    totalFlow: "総フロー",
    totalInvites: "総招待数",
    validMembers: "総有効メンバー"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "新しい会話",
    manual: "操作マニュアル",
    manualCardTitle: "操作マニュアルを見る",
    manualCardDesc: "入金・両替・振替・AI予測の図解手順",
    hello: "こんにちは、AIアシスタントです",
    hint: "相場分析、イベント/AI保険ルールの場所、チーム・招待、リスクについて聞けます。",
    placeholder: "質問を入力...",
    send: "送信",
    thinking: "分析中...",
    disclaimer: "参考情報であり投資助言ではありません。",
    bullish: "上昇",
    bearish: "下落",
    aiAnalysis: "AI要約",
    strategy: "取引戦略",
    reasoning: "推論",
    targetPrice: "目標 {price}",
    stopLoss: "損切 {price}",
    takeProfit: "利確 {price}",
    dirLong: "ロング",
    dirShort: "ショート",
    dirNeutral: "中立",
    analysisDone: "{symbol}（{timeframe}）の分析が完了しました。下のカードを確認してください。",
    analysisBtc: "BTCの短期分析です。",
    analysisEth: "ETHのレンジ分析です。",
    analysisRisk: "市場リスクの解説です。",
    suggestions: {
      btc1m: "BTCUSDT 1分の短期見通しを分析",
      ethTrend: "ETHは追うべき？様子見？",
      marketRisk: "今の市場リスク選好は？",
      eventRules: "イベント契約の保険ルール概要はどこ？",
      aiRules: "AI予測のルールとティアは？",
      teamWhere: "チーム詳細はどこで見る？",
      inviteWhere: "招待リンクと上位紐付けはどこ？"
    },
    guides: {
      eventRules: "イベント契約保険：イベント契約画面で保険スイッチ横のルールを開きます。「速覧」で保険料・上限・補償/プール、「完全契約」で正式条文を確認できます。",
      aiRules: "AI予測：下部中央→AI予測。次ラウンドのカウントダウン、保険ティア/ステップ、自主予測の残回数を確認。ルールは同じ保険シートのAI速覧と完全契約にあります。注文はティア金額と方向に一致させてください。",
      teamWhere: "チーム詳細：サイドバーまたはマイ→マイチーム。取引/運用収益を切替え、「チーム明細」で直紹介・出来高・等級・メンバーを確認。メンバーをタップで直紹介一覧へ。",
      inviteWhere: "招待と紐付け：サイドバー/マイ→友達招待で共有リンク（?ref=）をコピー。未紐付け時はログイン後に「上位を紐付け」が出ます。招待パラメータが無い場合は env のデフォルト上位アドレスが事前入力されます。"
    },
    generic: {
      a: "了解です。相場、イベント/AIルールの場所、チーム・招待を聞くか、下のクイック質問をどうぞ。",
      b: "OK。見通しカードと機能案内を提供します。",
      c: "イベントルール、AIルール、チーム詳細、招待リンクのクイック質問を試してください。"
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "直近約定",
    tabLp: "LP",
    tabPositions: "ポジション",
    tabRules: "ルール",
    colAddress: "アドレス",
    colTime: "時間",
    colType: "種別",
    colVolumePrice: "数量/価格",
    colTurnover: "約定代金",
    typeBuy: "買い",
    typeSell: "売り",
    empty: "データなし",
    share: "共有",
    rulesBody: "本市場は二値イベント予測です。決済前に板がロックされる場合があり、結果公表後に保有シェアで決済されます。リスクに留意し冷静にご参加ください。",
    priceJoule: "価格 (JOULE)",
    investJoule: "投入 (JOULE)",
    totalLiquidity: "総流動性",
    dealPrice: "約定価格",
    estProfit: "推定利益",
    jouleBalance: "JOULE残高: {n}",
    positionCount: "ポジション数: {n}",
    max: "最大",
    confirmOrder: "注文確認",
    ordering: "注文中...",
    enterAmount: "投入額を入力",
    invalidPrice: "有効な価格を入力",
    amountExceed: "投入額が残高を超えています",
    orderSuccess: "注文成功",
    poolSize: "プール規模",
    colBalance: "残高",
    shares: "{n}口",
    rulesTitle: "ルール説明",
    rulesValue: "説明なし",
    settleSource: "決済ソース",
    settleValue: "説明なし"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },

  operationManual: {
    title: "操作マニュアル",
    docTitle: "PANTA MARKET 操作マニュアル",
    sourceHint: "公式マニュアルを図解で再現。画像をタップして拡大できます。"
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "PANTAガバナンス・トークン",
    todayBurn: "本日のバーン",
    totalBurn: "累計バーン",
    burned: "バーン済み",
    initialSupply: "初期発行量",
    maxSupply: "最大発行量",
    finalCirculation: "最終流通量",
    contractAddress: "コントラクト：",
    copied: "コピーしました",
    ecoSection: "PANTA · AIアプリ生態系",
    ecoTabs: {
      market: "相場分析",
      arbitrage: "裁定ツール",
      acquisition: "グローバル獲得",
      video: "動画制作"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · クリエイティブ共同購入",
    groupTabs: {
      recommend: "おすすめ",
      hot: "人気",
      ipDrama: "IP短編",
      ipCollab: "IP共創",
      data: "データ"
    },
    filters: {
      all: "すべて",
      new: "新作",
      ending: "まもなく終了",
      highScore: "AI高評価"
    },
    project: {
      badge: "プラネット初公開",
      title: "《Panta AI · ライズ》AIアニメ短編",
      score: "AIスコア92",
      tagDrama: "IP短編",
      tagRights: "権利確定#0001",
      desc: "Panta AIが逆境を覆す、AIアプリ解説ショートドラマ"
    },
    values: {
      todayBurn: "321枚",
      totalBurn: "4212枚",
      initialSupply: "1000万枚",
      maxSupply: "2.1億枚",
      finalCirculation: "2100万枚"
    }
  },
  copyTrade: {
    menuTitle: "コピー取引",
    pageTitle: "コピー取引",
    fallback: "操作に失敗しました。後でもう一度お試しください。",
    pauseRule:
      "今週の決済完了時にまだ一時停止中の場合、来週にフォロー関係が自動解除されます。",
    pauseSuccess: "一時停止しました",
    resumeSuccess: "再開しました",
    endSuccess: "終了しました",
    followSuccess: "フォローを開始しました",
    pendingReviewToast: "トレーダー審査待ち",
    savedSuccess: "保存しました",
    registerSuccess: "登録完了。保証金を凍結しました。",
    cancelRequested: "登録解除を申請しました",
    cancelWithdrawn: "登録解除申請を撤回しました",
    kickedSuccess: "削除しました",
    approvedSuccess: "承認しました",
    rejectedSuccess: "拒否しました",
    filledToForm: "フォローフォームに入力しました",
    traderNotFound: {
      search:
        "トレーダーが見つかりません。ウォレットアドレスを確認するか、相手がまだリードを有効にしていない可能性があります。",
      business: "このトレーダーは現在利用できません",
    },
    tabs: {
      board: "ランキング",
      follows: "マイフォロー",
      join: "フォロー",
      trader: "リード",
      apps: "申請",
      fans: "フォロワー",
      rules: "ルール",
      settings: "ルール",
      follow: "フォロー",
    },
    ui: {
      refresh: "更新",
      search: "検索",
      loginWallet: "ウォレット接続",
      needLoginAction: "この操作にはウォレットログインが必要です（注文と同じ）。",
      needLoginTrader: "トレーダー関連APIにはログインが必要です。",
      loginToView: "ログインして表示",
      loading: "読み込み中…",
      empty: "なし",
      readonly: "読み取り専用",
      yes: "はい",
      no: "いいえ",
      immediate: "即時反映",
      current: "現在",
      nextWeek: "来週",
      pause: "一時停止",
      resume: "再開",
      end: "終了",
      save: "保存",
      kick: "削除",
      approve: "承認",
      reject: "拒否",
      requestCancel: "登録解除",
      withdrawCancel: "解除申請を撤回",
      confirmFollow: "フォロー確定",
      registerWithDeposit: "保証金を凍結して登録",
      registerConfirmTitle: "登録の確認",
      registerFreezeConfirm: "取引口座から {amount} JOULE の保証金が凍結されます。",
      platformSettings: "プラットフォーム設定",
      settingsTip:
        "コピー対象は通常モードかつ保険付きのリード注文のみです。未保険の通常注文とAI注文はコピーされず、生成されたCOPY注文も再リードしません。トレーダーは既存の注文APIを使い、orderSourceを渡さないでください。フォロワーは注文一覧でCOPY注文を確認できます。金額は小数第2位まで表示し、それ以降は切り捨てます。",
      deposit: "保証金",
      depositFreezeWeeks: "保証金凍結週数",
      maxFollowers: "フォロワー上限",
      shareRateRange: "分配率の範囲",
      shareRateDefault: "デフォルト分配率",
      shareRateNextWeek: "分配率は来週反映",
      pendingShareHint: "来週月曜から有効：{rate}",
      pendingMaxFollowersHint: "来週月曜から有効：{n}",
      depositFrozenShort: "凍結中",
      minFollowStake: "最低フォロー元本",
      ratioRange: "比率の範囲",
      maxSimultaneousFollows: "同時フォロー上限",
      defaultReview: "デフォルト審査",
      defaultMinBalance: "デフォルト残高しきい値",
      settlementTimezone: "決済タイムゾーン",
      leaderboardMeta: "ランキング最低場数 / 件数",
      leaderboardMetaValue: "{min} 件 / {size} 件",
      weekLeaderboard: "今週の勝率ランキング",
      expertLeaderboard: "トレーダーランキング",
      heroTitle: "実力トレーダーになる",
      heroDesc: "リード取引を開始して利益分配を獲得",
      heroActiveTitle: "実力トレーダーになりました",
      heroActiveDesc: "リード取引ステータスが有効です",
      heroRegister: "トレーダー登録",
      heroSettings: "リード設定",
      myLeading: "マイルード",
      winRateBoard: "勝率ランキング",
      pnlBoard: "利益ランキング",
      searchAddress: "アドレス検索",
      searchNicknameOrAddress: "ニックネームまたはアドレスを検索",
      searchQueryTooShort: "2文字以上入力してください",
      winRateShort: "勝率",
      followersLabel: "フォロワー数:",
      shareRateLabel: "分配率:",
      roundPnlLabel: "今期損益:",
      settledOrders: "決済 {n} 件",
      activeCount: "進行中",
      followStatsShort: "プール {pool} · 保留 {cash}",
      traderSettings: "リード設定",
      confirmChanges: "変更を確認",
      confirmCancel: "登録解除を確認",
      cancelModalTitle: "登録解除の説明",
      activeInProgress: "進行中",
      leadingFollowerCount: "フォロワー数 {n}",
      auditApps: "審査申請 {n}",
      leaderboardNote:
        "今週・通常ソース・保険付きの勝ち／負け決済注文のみを集計し、最低場数を満たしたトレーダーが掲載されます。全期間勝率でもAI勝率でもありません。チーム名や累計フォロー額は提供されません。",
      weekStart: "週開始（月曜）：{date}",
      leaderboardEmpty: "ランキングのトレーダーはいません。アドレスで検索してフォローできます。",
      winRate: "勝率 {n}%",
      boardSub:
        "分配 {share} · フォロワー {followers}/{max} · 決済 {orders} · 今週損益 {pnl} JOULE",
      searchTrader: "トレーダー検索",
      walletPlaceholder: "完全なウォレットアドレス 0x…",
      address: "アドレス",
      status: "ステータス",
      shareRate: "分配率",
      review: "審査",
      minBalance: "残高しきい値",
      followerCount: "フォロワー",
      startFollow: "フォロー開始",
      traderWallet: "トレーダーアドレス",
      followMode: "フォロー方式",
      ratioLabel: "比率（%）、範囲 {min} ~ {max}",
      insuranceMode: "保険モード",
      takeProfit: "利確（JOULE、任意）",
      stopLoss: "損切（JOULE、任意）",
      takeProfitPh: "今週の純利益が達したら一時停止",
      stopLossPh: "今週の純損失が達したら一時停止",
      followHint:
        "同時にフォローできるトレーダーは最大 {n} 名です。上限到達後に新規フォローすると、先に既存関係が終了します（影響なしのプレビューではありません）。パラメータ変更は終了してから再フォローしてください。",
      endConfirm:
        "このトレーダーとのコピー取引関係を終了しますか？終了後はシグナルに追従しません。履歴注文および確定済み損益には影響しません。",
      weeklyPoolHint:
        "プールは今週分であり、累計フォロー額ではありません。終了済み関係と審査待ち申請はこの一覧に含まれません。",
      networkUnclear:
        "結果を確認できません。更新して現在の関係またはトレーダー情報を確認してから再試行してください。",
      myFollows: "マイフォロー",
      noFollows: "フォロー関係がありません",
      followSub:
        "{mode}{ratio} · {insurance} · ロック分配 {share}",
      followStats:
        "今週損益 {pnl} · プール {pool} · 保留 {cash}",
      pauseReason: "一時停止理由：{reason}",
      registerTrader: "トレーダー登録",
      registerHint:
        "登録条件：帯単保証金として {amount} JOULE を一度に納付します（有効期間中は凍結、解除審査後に返還）。ウォレットごとにトレーダー身分は1つのみです。",
      registerBalanceHint:
        "保証金 {deposit} JOULE を凍結した後も、利用可能残高が ≥ {remain} JOULE である必要があります。",
      shareRateInput:
        "分配率（%）範囲 {min} ~ {max}。変更は次の周期から反映されます。",
      maxFollowersInput: "フォロワー上限（≤ {max}）",
      reviewMode: "承認方式",
      minBalanceInput: "フォロワー残高しきい値 · 任意（JOULE）",
      myTrader: "マイトレーダー情報",
      depositHeld: "{amount} / 凍結 {held}",
      currentFollowers: "現在のフォロワー数",
      cancelEffective: "登録解除の発効",
      depositRelease: "保証金返還",
      editParams: "設定を編集",
      editHint:
        "分配率／人数上限は来週反映、審査と残高しきい値は即時反映。決済ロックは日曜 22:00〜月曜 01:00 前（SGT）。サーバー時刻に従い、月曜 0:00 に自己判断で編集を再開しないでください。",
      shareRatePercent: "分配率（%）",
      minBalanceJoule: "残高しきい値（JOULE）",
      cancelTip:
        "解除後も今週はリードを継続し、来週月曜 0:00 に身分が終了します。保証金はさらに1週間凍結された後に返還されます。発効前なら撤回できます。",
      followers: "フォロワー",
      followerSub: "{mode}{ratio} · 今週損益 {pnl} · 保留 {cash}",
      applications: "審査待ち申請",
      noApplications: "申請がありません",
      fillForm: "フォローフォームに入力",
      needTraderFirst: "先にトレーダー登録してください",
      cancelRequestedAt: "登録解除申請時刻",
      ratioRangeInvalid: "比率は {min} ~ {max} の範囲で入力してください",
      shareRangeInvalid: "分配率は {min} ~ {max} の範囲で入力してください",
      maxFollowersInvalid: "フォロワー上限は {max} を超えられません",
      needShareRate: "分配率を入力してください",
      needMaxFollowers: "フォロワー上限を入力してください",
      needRatio: "比率を入力してください",
      badTakeProfit: "利確金額が正しくありません",
      badStopLoss: "損切金額が正しくありません",
      badMinBalance: "残高しきい値が正しくありません",
      insuranceShortFollow: "追随",
      insuranceShortOn: "常時ON",
      insuranceShortOff: "常時OFF",
      symbolSettings: "フォロー銘柄設定",
      symbolPickHint: "初期はすべてOFF。手動でONにし、いつでも変更できます",
      followSymbolHint: "このトレーダーが開放した銘柄から選択し、少なくとも1つONにしてください。",
      followSymbolWait: "先にトレーダーを検索してから、フォローする銘柄を選んでください。",
      symbolNeedOne: "少なくとも1つの銘柄をONにしてください",
      symbolNotAllowed: "選択した銘柄はこのトレーダーで許可されていません",
      effectiveSymbols: "有効",
      editSymbols: "銘柄を編集",
      allowedSymbols: "開放銘柄",
      weekPnlLabel: "今週損益:",
      currentNetPnlLabel: "現在の純損益",
      categoryCrypto: "暗号資産",
      categoryCommodity: "コモディティ",
      categoryEquity: "株式",
      symbolListCol: "一覧",
      symbolLeadCol: "リード",
      symbolFollowCol: "フォロー",
      symbolTags: "開放",
      leadingSymbols: "リード銘柄",
      detail: "明細",
      enabled: "ON",
      disabled: "OFF",
      held: "保有中",
      notHeld: "未保有",
      weekSettledOrders: "今期決済数",
      historicalNetPnl: "累計損益",
      copyTotalPnl: "コピー総損益",
      historicalSharePayout: "累計分配受取",
      allOrders: "すべて",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "進行中",
      settledOrdersTab: "決済済",
      colInterval: "期間",
      colOrderTime: "注文時間",
      colSelfPnl: "自己損益（保険料込）",
      colEstShare: "見込み分配（JOULE）",
      traderOrdersTitle: "{symbol} リード明細",
      followOrdersTitle: "{symbol} フォロー明細",
      selfPnl: "自己損益",
      estimatedShare: "見込み分配",
      inProgress: "進行中",
      followAssets: "資産別損益",
      byAsset: "資産別",
      followHistory: "終了済み",
      followStartTime: "開始：",
      followEndTime: "終了：",
      myPendingApps: "審査待ち",
      cashHeldHint: "今期見込み分配保留 {cash} JOULE",
      cashHeldFrozen: "今期見込み分配控除：{cash}（JOULE、凍結中）",
      followedTrader: "トレーダー",
      followInfo: "フォロー情報",
      totalPnlJoule: "合計損益（JOULE）",
      colTrader: "トレーダー",
      colPrincipal: "元本",
      colPnlShare: "損益（保険料込）／分配（JOULE）",
      traderInfo: "トレーダー情報",
      traderNotFound: "トレーダーが見つかりません",
      followSettingsRelationHint: "フォロー方式・保険・TP/SL は関係全体で共有され、選択中の全銘柄に適用されます。「フォロー設定」からいつでも変更できます。",
      followSettingsPrepareHint: "確認後、選択した銘柄に同一のフォロー設定でフォローを開始します。",
      followOptions: "フォローオプション",
      noFollowOptions: "フォローオプションがありません~",
      symbolFollowing: "フォロー中",
      symbolPaused: "一時停止",
      symbolIdle: "未フォロー",
      cancelFollowSymbol: "フォロー解除",
      cancelSymbolConfirm: "{symbol} のフォローを解除しますか？",
      cancelLastSymbolConfirm: "これが最後の銘柄です。解除するとフォロー関係全体が終了します。続行しますか？",
      followNow: "今すぐフォロー",
      followAll: "フォロー",
      unfollowAll: "すべて解除",
      unfollowAllConfirm:
        "このトレーダーの全銘柄フォローを解除しますか？フォロー関係全体が終了します。",
      followSettings: "フォロー設定",
      goFollowSettings: "開く ›",
      copyAccountBalance: "コピー口座：{amount} JOULE",
      orderFollowerCount: "この注文のフォロワー数",
      copyingStatus: "コピー中",
      roleStatusLeading: "リード中",
      roleStatusFollowing: "コピー中",
      roleStatusPaused: "コピー一時停止",
      copyOrderTag: "コピー",
      copyOpenPositions: "コピー建玉",
      copyInsuredOrdinary: "通常保険あり",
      copyUninsured: "未保険",
      addSymbolHint: "この銘柄を現在のフォローに追加します。",
      myRelationStatus: "マイフォロー",
      latestSettlements: "最新決済",
      resumeRelationFirst: "関係が全体停止中です。銘柄操作の前に「マイフォロー」で再開してください。",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "種別",
      colPnlJoule: "損益（JOULE）",
      tpSl: "利確／損切",
      takeProfitPhFull: "今週の純利益到達後に一時停止 — 任意（JOULE）",
      stopLossPhFull: "今週の純損失到達後に一時停止 — 任意（JOULE）",
      confirmModify: "変更を確認",
      clearSearch: "ランキングに戻る",
      searchResultHint: "検索結果（タップでトレーダー情報へ）",
      searchEmpty: "トレーダーが見つかりません",
      noMoreSettlements: "これ以上ありません",
    },
    errors: {
      AUTH_REQUIRED: "先にウォレットを接続してください",
      AUTH_UNAVAILABLE: "ログインサービスが一時的に利用できません。後でもう一度お試しください。",
      POSTGRES_REQUIRED: "サービスが一時的に利用できません。後でもう一度お試しください。",
      USER_NOT_FOUND: "ユーザーが見つかりません。再ログインしてからお試しください。",
      INVALID_WALLET: "完全なウォレットアドレスを入力してください",
      INVALID_QUERY: "検索キーワードが無効です。2文字以上入力してください",
      INVALID_AMOUNT: "金額の形式が正しくありません",
      INVALID_PARAM: "パラメータが不正です。確認して再試行してください。",
      INVALID_FOLLOW: "自分の取引はフォローできません",
      TRADER_EXISTS: "このウォレットは既にトレーダーです。再登録は不要です。",
      TRADER_FULL: "このトレーダーはフォロワー上限に達しています",
      TRADER_CANCELLED: "このトレーダーアカウントは解除済みです",
      TRADER_REGISTER_FAILED: "トレーダー登録に失敗しました。後でもう一度お試しください。",
      TRADER_SETTINGS_FAILED: "トレーダー設定の保存に失敗しました。後でもう一度お試しください。",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "利用可能残高が不足しているため保証金を凍結できません",
      BALANCE_TOO_LOW: "コピー口座の利用可能残高がこのトレーダーのしきい値未満です。取引口座から振り替えてください",
      COPY_BALANCE_ZERO: "コピー口座残高が 0 です。取引口座から振り替えてください",
      INSUFFICIENT_FUNDS: "取引口座残高不足のためコピー口座へ振替できません",
      COPY_TRADE_BALANCE_INSUFFICIENT: "コピー口座の利用可能残高不足（凍結元本/分潤は引き出し不可）",
      ACCOUNT_NOT_FOUND: "アカウントエラーです。後でもう一度お試しください。",
      ACCOUNT_CONFLICT: "アカウント更新中です。後でもう一度お試しください。",
      FOLLOW_EXISTS: "既にこのトレーダーをフォローしています",
      FOLLOW_LIMIT:
        "進行中のフォロー関係があります。他のトレーダーをフォローする前に終了してください。",
      FOLLOW_FAILED: "フォロー開始に失敗しました。後でもう一度お試しください。",
      FOLLOW_NOT_FOUND: "フォロー関係が見つかりません",
      PAUSE_FAILED: "フォロー一時停止に失敗しました。後でもう一度お試しください。",
      RESUME_FAILED: "フォロー再開に失敗しました。後でもう一度お試しください。",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "フォロー終了に失敗しました。後でもう一度お試しください。",
      APPLICATION_NOT_FOUND: "審査待ち申請が見つかりません",
      APPROVE_FAILED: "申請の承認に失敗しました。後でもう一度お試しください。",
      REJECT_FAILED: "申請の拒否に失敗しました。後でもう一度お試しください。",
      KICK_FAILED: "フォロワーの削除に失敗しました。後でもう一度お試しください。",
      SETTLEMENT_WINDOW: "決済ウィンドウ中はトレーダー設定を変更できません",
      CANCEL_FAILED: "登録解除の申請に失敗しました。後でもう一度お試しください。",
      CANCEL_NOT_PENDING: "撤回できる登録解除申請がありません",
      CANCEL_WITHDRAW_FAILED: "登録解除の撤回に失敗しました。後でもう一度お試しください。",
      COPY_SETTINGS_MISSING: "コピー取引設定の準備ができていません。後でもう一度お試しください。",
      INVALID_SYMBOL: "対応銘柄を少なくとも1つ選択してください",
      SYMBOL_NOT_ALLOWED: "このトレーダーが許可していない銘柄が含まれています",
      TRADER_BALANCE_TOO_LOW: "保証金凍結後の利用可能残高が不足しているため登録できません",
      TIMEOUT: "操作に失敗しました。後でもう一度お試しください。",
      NETWORK: "操作に失敗しました。後でもう一度お試しください。",
    },
    status: {
      ACTIVE: "フォロー中",
      PAUSED: "一時停止",
      ENDED: "終了",
      PENDING_REVIEW: "トレーダー審査待ち",
      CANCEL_PENDING: "登録解除中",
      CANCELLED: "登録解除済み",
    },
    traderStatus: {
      ACTIVE: "リード中",
      CANCEL_PENDING: "退出中",
      CANCELLED: "取消済み",
    },
    pauseReason: {
      USER: "ユーザーによる一時停止",
      INSUFFICIENT_BALANCE: "コピー口座残高不足のため一時停止",
      TAKE_PROFIT: "利確トリガー",
      STOP_LOSS: "損切トリガー",
      TRADER_KICK: "トレーダーにより削除",
      SWITCH: "トレーダー切替",
      SETTLEMENT_CLEANUP: "週次決済で削除",
      TRADER_CANCEL: "トレーダー登録解除",
    },
    followMode: {
      EQUAL: "同額",
      RATIO: "比率",
    },
    insuranceMode: {
      FOLLOW: "トレーダーに追随",
      ALWAYS_ON: "常時ON",
      ALWAYS_OFF: "常時OFF",
    },
    reviewMode: {
      AUTO: "自動承認",
      MANUAL: "手動審査",
    },
    applicationStatus: {
      PENDING: "審査待ち",
      APPROVED: "承認済み",
      REJECTED: "拒否済み",
      CANCELLED: "取消済み",
      PENDING_REVIEW: "審査待ち",
    },
  },}
